var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-5"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"dot-pulse mx-auto"})])])
}]

export { render, staticRenderFns }